export function useUser() {
  return {
    user: null,
    loading: false,
    error: null,
    fetchUser: async () => undefined,
    clearUser: () => undefined,
  }
}
